import React, { useState } from 'react'
import styled from 'styled-components/macro'
import { getGelTokens } from '@tal-gel/theming'
import { GelParagraph, GelHeading2, GelButton } from '@tal-gel/components'

import Step from '../Step/Step'
// import Input from './Input'
import RadioButtonGroup from './GEL/RadioButtonGroup'
import DateInput from './GEL/DateInput'
import SelectInput from './GEL/SelectInput'
import TwoNumberInputs from './GEL/TwoNumberInputs'

const Component = styled.div`
  background-color: #fff;
  max-width: 768px;
  border-radius: 12px;
  width: 100%;
  min-height: 100vh;

  @media only screen and (min-width: 768px) {
    min-height: auto;
  }
`

const OuterWrapper = styled.div`
  background-color: ${() => getGelTokens().brand.brandColorGrayT05};
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`

const InnerWrapper = styled.div`
  @media only screen and (min-width: 768px) {
    padding: 28px 28px 66px 28px;
  }
`

const Wrapper = styled.div`
  padding: 24px 24px;

  @media only screen and (min-width: 768px) {
    padding: 0;
    max-width: 540px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`

const PrevButtonContainer = styled.div`
  margin-left: 24px;
  margin-top: 16px;
  min-height: 36px;

  @media only screen and (min-width: 768px) {
    margin-left: auto;
    margin-right: auto;
    /* margin-top: 32px; */
    margin-top: 0;
    /* max-width: 1000px; */
  }
`

const ImageContainer = styled.div`
  margin: 15px 0 50px;
  justify-content: center;
  display: flex;
`

const Circle = styled.div`
  border-radius: 50%;
  background-color: ${() => getGelTokens().brand.brandColorPrimary1T20};
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Image = styled.img``

const QuestionOptionsWrapper = styled.div`
  margin-top: 52px;
  display: flex;
  justify-content: center;
`

const ReadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`

const Question = ({
  step,
  data,
  onQuestionAnswered,
  onBackClick,
  shouldBackButtonExist,
  totalQuestionsLength,
  totalStep,
  questionGroupNumber,
  demo
}) => {
  const [collapsed, setCollapsed] = useState(true)

  const { questions, imageQuestion, imageQuestionDemo, title } = data
  const currentQuestion = questions[step]

  const handleQuestionAnswered = (arg) => {
    setCollapsed(true)
    onQuestionAnswered(arg)
  }

  const getQuestionOptions = () => {
    const questionProps = {
      question: currentQuestion,
      onQuestionAnswered: handleQuestionAnswered
    }

    switch (currentQuestion.type) {
      case 'date':
        return <DateInput {...questionProps} />
      case 'select':
        return <SelectInput {...questionProps} />
      // looks like currently there's no input questions
      // case 'input':
      //   return <Input {...questionProps} />
      case 'additions':
        return <TwoNumberInputs {...questionProps} />
      default:
        // one
        return <RadioButtonGroup {...questionProps} />
    }
  }

  const handleReadMoreClick = () => {
    setCollapsed(!collapsed)
  }

  return (
    <OuterWrapper>
      <Component>
        <Step current={totalStep + 1} max={totalQuestionsLength} />
        <InnerWrapper>
          <PrevButtonContainer>
            {shouldBackButtonExist && (
              <GelButton
                secondary
                medium
                iconLeft='ArrowLeft'
                onClick={onBackClick}
              >
                Prev
              </GelButton>
            )}
          </PrevButtonContainer>
          <Wrapper>
            <ImageContainer>
              <Circle>
                <Image
                  src={demo ? imageQuestionDemo : imageQuestion}
                  alt={title}
                  demo={demo}
                />
              </Circle>
            </ImageContainer>
            <GelParagraph
              marginBottom={24}
              textAlign='center'
              style={{
                fontWeight: '400',
                fontFamily: 'Pluto Sans Condensed',
                color: getGelTokens().brand.brandColorGrayT40
              }}
            >
              {title} (Part {questionGroupNumber + 1} of 2)
            </GelParagraph>
            <GelHeading2 textAlign='center' marginBottom={24}>
              {currentQuestion.title}
            </GelHeading2>
            {currentQuestion.info && (
              <>
                <GelParagraph
                  marginBottom={12}
                  textAlign='center'
                  className={collapsed && 'readMore'}
                  large
                  style={{
                    fontWeight: '400',
                    fontSize: '18px',
                    fontFamily: 'Pluto Sans Condensed',
                    color: getGelTokens().brand.brandColorGrayT50,
                    lineHeight: '20px'
                  }}
                >
                  {currentQuestion.info}
                </GelParagraph>
                {collapsed && (
                  <ReadMoreWrapper className='readMoreWrapper'>
                    <GelButton
                      tertiary
                      medium
                      iconRight='ChevronDown'
                      onClick={handleReadMoreClick}
                    >
                      Read More
                    </GelButton>
                  </ReadMoreWrapper>
                )}
              </>
            )}
            <QuestionOptionsWrapper>
              {getQuestionOptions()}
            </QuestionOptionsWrapper>
          </Wrapper>
        </InnerWrapper>
      </Component>
    </OuterWrapper>
  )
}

export default Question
